import api from './api';
import axios from 'axios';

let API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Eliminar slash final si existe
if (API_BASE_URL.endsWith('/')) {
    API_BASE_URL = API_BASE_URL.slice(0, -1);
}

// Asegurar que la URL termine en /api si no lo tiene
if (API_BASE_URL && !API_BASE_URL.endsWith('/api')) {
    API_BASE_URL = `${API_BASE_URL}/api`;
}

const authService = {
    // Login
    login: async (email, password) => {
        const response = await api.post('/auth/login/', { email, password });
        const { access, refresh } = response.data;

        // Guardar tokens
        localStorage.setItem('access_token', access);
        localStorage.setItem('refresh_token', refresh);

        return response.data;
    },

    // Logout
    logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
    },

    // Registro (público, no requiere token)
    registerCompany: async (data) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/auth/register-company/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    checkAvailability: async (data) => {
        const response = await axios.post(`${API_BASE_URL}/auth/check-availability/`, data);
        return response.data;
    },

    verifyEmail: async (data) => {
        // Usar axios directamente para evitar adjuntar token (que causaría 401 si el usuario está inactivo)
        const response = await axios.post(`${API_BASE_URL}/auth/verify-email/`, data);
        return response.data;
    },

    requestPasswordReset: async (email) => {
        const response = await axios.post(`${API_BASE_URL}/auth/password-reset-request/`, { email });
        return response.data;
    },

    confirmPasswordReset: async (data) => {
        const response = await axios.post(`${API_BASE_URL}/auth/password-reset-confirm/`, data);
        return response.data;
    },

    getCurrentUser: async () => {
        const response = await api.get('/usuarios/me/');
        localStorage.setItem('user', JSON.stringify(response.data));
        return response.data;
    },

    // Verificar si está autenticado
    isAuthenticated: () => {
        return !!localStorage.getItem('access_token');
    },

    // Obtener usuario del localStorage
    getUser: () => {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    },

    // ===== Pagos (Simulated Gateway) =====

    getPaymentOrder: async (pagoId) => {
        const response = await axios.get(`${API_BASE_URL}/payments/order/${pagoId}/`);
        return response.data;
    },

    confirmSimulatedPayment: async (pagoId) => {
        const response = await axios.post(`${API_BASE_URL}/payments/confirm-simulated/${pagoId}/`);
        return response.data;
    },
};

export default authService;
